var _g, _path, _path2, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDoubleArrowUp = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3428_86856)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 16.5,
    r: 14.5,
    transform: "rotate(180 18.5 16.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 16.5,
    r: 14,
    transform: "rotate(180 18.5 16.5)",
    stroke: "#DFE3E9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 11.8281L13.05 16.7781L11.636 15.3641L18 9.00007L24.364 15.3641L22.95 16.7781L18 11.8281Z",
    fill: "#201B7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18.8281L13.05 23.7781L11.636 22.3641L18 16.0001L24.364 22.3641L22.95 23.7781L18 18.8281Z",
    fill: "#201B7C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3428_86856",
    x: 9.53674e-7,
    y: 0,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3428_86856"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3428_86856",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDoubleArrowUp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/double-arrow-up.b0df2c96.svg";
export { ForwardRef as ReactComponent };